import { render, staticRenderFns } from "./BindsTableHeadSelection.vue?vue&type=template&id=08b2d9a1&"
import script from "./BindsTableHeadSelection.vue?vue&type=script&lang=js&"
export * from "./BindsTableHeadSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports